import { NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { B2bEnvironment } from './environment.interface';
import { environment as prodEnvironment } from './environment.prod';

// Variable global para la configuración runtime
let _runtimeConfig: B2bEnvironment | null = null;

// Función para actualizar la configuración desde RuntimeConfigService
export function setRuntimeConfig(config: B2bEnvironment): void {
  _runtimeConfig = config;
  console.log('🔧 Runtime config actualizada:', config.CLIENTE);
}

// Función para obtener la configuración actual
export function getRuntimeConfig(): B2bEnvironment {
  return _runtimeConfig || prodEnvironment;
}

// Proxy dinámico que retorna valores runtime si existen, sino prodEnvironment
export const environment = new Proxy(prodEnvironment, {
  get(target: B2bEnvironment, prop: keyof B2bEnvironment): any {
    // Si hay configuración runtime, úsala
    const runtime = getRuntimeConfig();
    if (runtime && prop in runtime) {
      return runtime[prop];
    }
    // Fallback al environment por defecto
    return target[prop];
  }
});

// NOTA: 
// - En desarrollo con ng serve --configuration=musgrave: fileReplacements reemplaza este archivo
// - En Docker con runtime config: RuntimeConfigService carga y actualiza _runtimeConfig

// export const environment_old: B2bEnvironment = {
//   production: false,
//   URL_LINK_LOGO: 'https://www.asg-si.com',
//   CLIENTE: 'tharsis',
//   LOGO: 'assets/img/LOGOTIPOS_GEMMA_6_RESIZED.png',
//   ICON: 'assets/img/asg/favicon.ico',
//   TITLE: 'Gemma SHOP - tienda online !!!',
//   LOGO_BACKGROUND_COLOR: '#fff',
//   SECTOR_BACKGROUND_COLOR: '#00bfa5', // TEAL-A700 #00bfa5
//   SERVER_IMG: 'https://asg-gemmasales.asg-si.net/gemmasales/datos/img',
//   IMG_EXTENSION: 'png',
//   SERVER_URL: 'https://gemma-ords-api.asg-si.net:8443/ords/gemma',
//   SERVER_GM_URL: 'https://gemma-ords-api.asg-si.net:8443/ords/gemma/gemma/conf/api',
//   SERVER_USU_URL: 'http://localhost:30012/gshop/usu/api/v1', // localhost| 192.168.0.3
//   SERVER_ART_URL: 'http://localhost:30012/gshop/art/api/v1', // localhost| 192.168.0.3
//   SERVER_PED_URL: 'http://localhost:30012/gshop/ped/api/v1', // localhost| 192.168.0.3
//   SERVER_CLI_URL: 'http://localhost:30012/gshop/cli/api/v1', // localhost| 192.168.0.3
//   SERVER_EAN_URL: 'http://localhost:30012/gshop/art/prod/api/v1',
//   SERVER_PORTAL_URL: 'http://localhost:30012/gshop/portal/api/v1',
//   REPORT_SERVER_URL: 'http://gmmservice-lb-oci.asg-si.net:7777/reports/rwservlet?server=repsrv_dmsg1&userid=GEMMA/asg&destype=cache&desformat=pdf&report=FPEDCLI_GEN',
//   SERVER_AUTH: 'Basic b3Jkc19kbXNnX2dlbW1hOmFzZw==',
//   OAUTH_URL_PHP: 'https://asg-gemmashop.asg-si.net/api/index.php',
//   OAUTH_URL_ORDS: 'https://gemma-ords-api.asg-si.net:8443/ords/gemma/oauth/token',
//   // API de autenticación de usuario
//   OAUTH_URL_GMAUTH: 'https://asg-gmauth.asg-si.net/realms/asg-gmcloak-b2b/protocol/openid-connect',
//   // Credenciales usuario login. Unicos x empresa-app
//   AUTH_TOKEN: true,
//   CLIENT_ID: 'gmcloak-admin',
//   CLIENT_SECRET: 'u7dERpKgXjKEkaAydw4h2JEUGmVGFSs2',
//   // CLIENT_SECRET: 'u7dERpKgXjKEkaAydw4h2JEUGmVGFSs2',
//   // Obtener token de administrador para cambio de constraseña
//   OAUTH_URL_GMAUTH_ADMIN: 'https://asg-gmauth.asg-si.net/realms/master/protocol/openid-connect/token',
//   // Credenciales de administrador
//   //   ASB b2b app --> asg-b2b@application.com/b2b.App Role: user-admin-asg-b2b
//   // client_id =gmcloak-admin
//   // cliente_secret=u7dERpKgXjKEkaAydw4h2JEUGmVGFSs2
//   ADMIN_ID: "gmauth-admin",
//   PASSWORD_ADMIN: "b2b.App",
//   USERNAME_ADMIN: "asg-b2b@application.com",
//   ADMIN_REALM: "asg-gmcloak-b2b",
//   // Servicio de administración de cambio de claves
//   SERVER_ADM_URL: 'http://localhost:31018/api/v1/gmauthadm',
//   // Realm de aplicación al que se le cambia la contraseña
//   // ADMIN_REALM: 'asg-gmcloak-b2b',
//   // CloudFlare Turnstile
//   TURNSTILE_CLOUDFLARE: false,
//   TURNSTILE_SITE_KEY: '0x4AAAAAABu6wwkprGB7aaDB',

//   LOGIN_EMAIL: false,
//   VER_PROD_LOGOUT: true,
//   VER_REFERENCIA_LOGOUT: true,
//   COMPRA_TB: true,
//   TIPO_BULTO: 'F,C,K',
//   TIPO_BULTO_DEF: 'F',
//   PORTES: true,
//   FSERVICIO: true,
//   VER_CLICK_COLLECT: true,
//   VER_CONFIRMA_COMPRA: true,
//   VER_PVP_CAJA: true,
//   VER_PVP_IVA: false,
//   COMPRAR_SIN_STOCK: 'N', // [N]ocontrolar,[V]isualizar->icono candado,no [P]ermitir
//   BOTON_COMPRA_BULTO: true,
//   CLI_CATALOGO: 0,
//   ALM_CATALOGO: 2,
//   VER_LOGO_GMSHOP: false,
//   FILTROS_SHOP: { novedad: true, miscompras: true, mascomprado: true, marcapropia: true, oferta: true, eslista: true, espedido: true },
//   MENSAJE_COMPRA: 'Informamos que la valoración total del pedido podría diferir a causa de aquellas referencias cuyo peso sea variable!!',
//   VER_HOME: true,
//   VER_HOME_LOGEADO: true,
//   VER_PORTAL: true,
//   LOGIN_IS_HOME: false,
//   URL_LOGOUT: 'https://www.asg-si.com',
//   CANT_TOPE: 99,
//   KILO_TOPE: 99,
//   LOGIN_IMG: null,
//   LOGIN_IMG_PROFILE_VIEW: true,
//   MULTI_FOTOS: true,
//   AGRUPACION: 'sector',
//   REPORT_FCF: 'FCFGEN_GPDF',
//   AYUDA_VIDEOS: ['', ''],
//   ART_PESO_VER_PESO: false,
//   PORTAL_MENU: { factura: true, faltas: false, dec347: false, pagos: false, pendiente: false, },
//   REPORT_DEC347: 'CARTA_CLI_TRI_DEC347',
//   COOKIE_VER: false,
//   COOKIE_domain: 'tienda.gemmab2b.es',
//   COOKIE_header: 'Cookies usadas en este sitio!',
//   COOKIE_message: 'Utilizamos cookies para asegurar que damos la mejor experiencia al usuario en nuestra web.',
//   COOKIE_dismiss: 'Aceptar',
//   COOKIE_allow: 'Permitir cookies',
//   COOKIE_deny: 'Rechazar',
//   COOKIE_link: 'Más información',
//   COOKIE_cookiePolicyHref: '/politica-cookies',
//   COOKIE_policy: 'Política de cookies',
//   COOKIE_privacyPolicyHref: '/politica-privacidad',
//   COOKIE_privacyGroupPolicyHref: '',
//   PWD_MIN_LENGTH: 12,
//   PWD_PATTERN: "(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{4,}",
//   LOGIN_INTENTOS_AVISO: 3

// };

// export const cookieConfig: NgcCookieConsentConfig = {
//   cookie: {
//     domain: 'asg-gemmasales.asg-si.net'// it is recommended to set your domain, for cookies to work properly
//   },
//   palette: {
//     popup: {
//       background: '#00bfa5'
//     },
//     button: {
//       background: '#f1d600'
//     }
//   },
//   theme: 'edgeless',
//   type: 'opt-out',
//   layout: 'my-custom-layout',
//   layouts: {
//     'my-custom-layout': '{{messagelink}}{{compliance}}'
//   },
//   elements: {
//     messagelink: `
//     <span id="cookieconsent:desc" class="cc-message">{{message}}
//       <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{cookiePolicyHref}}" target="_self" rel="noopener">{{cookiePolicyLink}}</a>,
//       <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_self" rel="noopener">{{privacyPolicyLink}}</a>
//     </span>
//     `,
//   },
//   content: {
//     message: 'By using our site, you acknowledge that you have read and understand our ',

//     cookiePolicyLink: 'Política de cookies',
//     cookiePolicyHref: 'https://cookie.com',

//     privacyPolicyLink: 'Política de privacidad',
//     privacyPolicyHref: 'https://privacy.com',

//   }
// };





// CONFIGURACIÓN ANTIGUA COMENTADA - NO USAR
// La configuración ahora viene de environment.prod + runtime-config.json
/*
import { NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { B2bEnvironment } from './environment.interface';

export const environment_OLD: B2bEnvironment = {
  production: false,
  URL_LINK_LOGO: 'https://www.dialsur.es',
  CLIENTE: 'musgrave',
  LOGO: 'assets/img/musgrave/DS_sinfondo.png',
  ICON: 'assets/img/musgrave/favicon.ico',
  TITLE: 'Tienda Dialsur',
  LOGO_BACKGROUND_COLOR: '#fff',
  SECTOR_BACKGROUND_COLOR: '#0073ae', // TEAL-A700 #00bfa5
  SERVER_IMG: 'https://musgrave-gemmasales.asg-si.net/gemmasales/datos/img',
  IMG_EXTENSION: 'jpg',
  // SERVER_URL: deprecated
  // SERVER_GM_URL: deprecated
  //SERVER_USU_URL_ords: 'https://gemma-ords-api.asg-si.net:8443/ords/musg/gshop/usu/api/v1',
  SERVER_USU_URL: 'http://localhost:30012/gshop/usu/api/v1',
  // SERVER_USU_URL: 'https://musgpre-gmb2bapi.asg-si.net/gshop/usu/api/v1',
  SERVER_ART_URL: 'http://localhost:30012/gshop/art/api/v1',
  // SERVER_ART_URL: 'https://musgpre-gmb2bapi.asg-si.net/gshop/art/api/v1',
  SERVER_PED_URL: 'http://localhost:30012/gshop/ped/api/v1',
  // SERVER_PED_URL: 'https://musgpre-gmb2bapi.asg-si.net/gshop/ped/api/v1',
  SERVER_CLI_URL: 'http://localhost:30012/gshop/cli/api/v1',
  // SERVER_CLI_URL: 'https://musgpre-gmb2bapi.asg-si.net/gshop/cli/api/v1',
  SERVER_EAN_URL: '',
  SERVER_PORTAL_URL: 'http://localhost:30012/gshop/portal/api/v1',
  // SERVER_PORTAL_URL: 'https://musgpre-gmb2bapi.asg-si.net/gshop/portal/api/v1',
  // REPORT_SERVER_URL: deprecated
  // SERVER_AUTH: deprecated
  // OAUTH_URL_PHP: deprecated
  // OAUTH_URL_ORDS: deprecated
  // API de autenticación de usuario
  OAUTH_URL_GMAUTH: 'https://asg26-gmauth.asg-si.net/realms/muspre-gmcloak-b2b/protocol/openid-connect',
  // Credenciales usuario login. Unicos x empresa-app
  AUTH_TOKEN: true,
  CLIENT_ID: 'gmcloak-admin',
  CLIENT_SECRET: 'M7zSSG1qBrqq26JtW7jtPOjU32Oso4PE',
  // Obtener token de administrador para cambio de constraseña
  OAUTH_URL_GMAUTH_ADMIN: 'https://asg26-gmauth.asg-si.net/realms/master/protocol/openid-connect/token',
  // Credenciales de administrador
  ADMIN_ID: 'gmauth-admin',
  PASSWORD_ADMIN: 'b2b.Muspre.App',
  USERNAME_ADMIN: 'muspre-b2b@application.com',
  // Servicio de administración de cambio de claves
  SERVER_ADM_URL: 'https://musgpre-gmauthadm.asg-si.net/api/v1/gmauthadm',
  // SERVER_ADM_URL: 'http://localhost:31018/api/v1/gmauthadm',
  // Realm de aplicación al que se le cambia la contraseña
  ADMIN_REALM: 'muspre-gmcloak-b2b',
  LOGIN_EMAIL: false,
  VER_PROD_LOGOUT: true,
  VER_REFERENCIA_LOGOUT: false,
  COMPRA_TB: true,
  TIPO_BULTO: 'U,F,C,K',
  TIPO_BULTO_DEF: 'C',
  PORTES: true,
  FSERVICIO: true,
  VER_CLICK_COLLECT: false,
  VER_CONFIRMA_COMPRA: true,
  VER_PVP_CAJA: true,
  VER_PVP_IVA: false,
  COMPRAR_SIN_STOCK: 'P', // [N]ocontrolar,[V]isualizar->icono candado,no [P]ermitir
  BOTON_COMPRA_BULTO: true,
  CLI_CATALOGO: 0,
  ALM_CATALOGO: 80007,
  VER_LOGO_GMSHOP: false,
  FILTROS_SHOP: { novedad: true, miscompras: true, mascomprado: true, marcapropia: true, oferta: true, eslista: true, espedido: true },
  MENSAJE_COMPRA: 'Informamos que la valoración total del pedido podría diferir a causa de aquellas referencias cuyo peso sea variable!!',
  VER_HOME: false,
  VER_HOME_LOGEADO: false,
  VER_PORTAL: true,
  LOGIN_IS_HOME: true,
  URL_LOGOUT: '',
  CANT_TOPE: 99,
  KILO_TOPE: 99,
  LOGIN_IMG: 'assets/img/musgrave/original_rum.jpg',
  LOGIN_IMG_PROFILE_VIEW: false,
  MULTI_FOTOS: true,
  AGRUPACION: 'seccion', // 'SECCION'
  REPORT_FCF: 'FCFMUSGRAVE_GPDF',
  AYUDA_VIDEOS: ['cCLGmzjYp_E', ''],
  ART_PESO_VER_PESO: false,
  PORTAL_MENU: { factura: true, faltas: false, dec347: true, pagos: false, pendiente: false, },
  REPORT_DEC347: 'CARTA_CLI_TRI_DEC347',
  COOKIE_VER: true,
  COOKIE_domain: 'tienda.dialsur.es',
  COOKIE_header: 'Cookies usadas en este sitio!',
  COOKIE_message: 'Utilizamos cookies para asegurar que damos la mejor experiencia al usuario en nuestra web.',
  COOKIE_dismiss: 'Aceptar',
  COOKIE_allow: 'Permitir cookies',
  COOKIE_deny: 'Rechazar',
  COOKIE_link: 'Más información',
  COOKIE_cookiePolicyHref: '/politica-cookies',
  COOKIE_policy: 'Política de cookies',
  COOKIE_privacyPolicyHref: '/politica-privacidad',
  COOKIE_privacyGroupPolicyHref: 'https://musgrave.es/aviso-legal-politica-privacidad/',
  // CloudFlare Turnstile
  TURNSTILE_CLOUDFLARE: true,
  TURNSTILE_SITE_KEY: '0x4AAAAAABu6wwkprGB7aaDB',
  PWD_MIN_LENGTH: 12,
  PWD_PATTERN: "(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{4,}",
  LOGIN_INTENTOS_AVISO: 3
};
*/

export const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'tienda.dialsur.es'// it is recommended to set your domain, for cookies to work properly
  },
  position: 'bottom',
  palette: {
    popup: {
      background: '#0073ae'
    },
    button: {
      background: '#f1d600'
    }
  },
  theme: 'edgeless',
  type: 'info',
  layout: 'my-custom-layout',
  layouts: {
    'my-custom-layout': '{{messagelink}}{{compliance}}'
  },
  elements: {
    messagelink: `
    <span id="cookieconsent:desc" class="cc-message">{{message}}
      <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{cookiePolicyHref}}" target="_self" rel="noopener">{{cookiePolicyLink}}</a>,
      <a aria-label="learn more about our privacy policy" tabindex="1" class="cc-link" href="{{privacyPolicyHref}}" target="_self" rel="noopener">{{privacyPolicyLink}}</a>
      <a aria-label="learn more about our privacy policy" tabindex="2" class="cc-link" href="{{privacyGroupPolicyHref}}" target="_blank" rel="noopener">{{privacyGroupPolicyLink}}</a>
      <!-- and our <a aria-label="learn more about our terms of service" tabindex="2" class="cc-link" href="{{tosHref}}" target="_blank" rel="noopener">{{tosLink}}</a>-->
    </span>
    `,
  },
  content: {
    message: 'By using our site, you acknowledge that you have read and understand our ',

    cookiePolicyLink: 'Política de cookies',
    cookiePolicyHref: 'https://cookie.com',

    privacyPolicyLink: 'Política de privacidad',
    privacyPolicyHref: 'https://privacy.com',

    privacyGroupPolicyLink: 'Política de privacidad grupo Musgrave',
    privacyGroupPolicyHref: 'https://tos.com',
  }
};